/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShellRouteImport } from './routes/_shell'
import { Route as CompleteProfileRouteImport } from './routes/complete-profile'
import { Route as PowitanieRouteImport } from './routes/powitanie'
import { Route as RefusedRouteImport } from './routes/refused'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as ShellIndexRouteImport } from './routes/_shell.index'
import { Route as ShellBuddyRouteImport } from './routes/_shell.buddy'
import { Route as ShellCwiczeniaRouteImport } from './routes/_shell.cwiczenia'
import { Route as ShellCzatRouteImport } from './routes/_shell.czat'
import { Route as ShellKontoRouteImport } from './routes/_shell.konto'
import { Route as ShellNagraniaRouteImport } from './routes/_shell.nagrania'
import { Route as ShellPulpitRouteImport } from './routes/_shell.pulpit'
import { Route as ShellRezerwacjeRouteImport } from './routes/_shell.rezerwacje'
import { Route as ShellStronaRouteImport } from './routes/_shell.strona'
import { Route as ShellWideoRouteImport } from './routes/_shell.wideo'
import { Route as ShellKlienciIndexRouteImport } from './routes/_shell.klienci.index'
import { Route as ShellKlienciClientIdRouteImport } from './routes/_shell.klienci.$clientId'
import { Route as ShellKlienciArchiwumRouteImport } from './routes/_shell.klienci.archiwum'
import { Route as ShellKlienciFormularzRouteImport } from './routes/_shell.klienci.formularz'
import { Route as ShellKontoGoogleRouteImport } from './routes/_shell.konto_.google'
import { Route as ShellPlansIndexRouteImport } from './routes/_shell.plans.index'
import { Route as ShellPlansPlanIdRouteImport } from './routes/_shell.plans.$planId'
import { Route as ShellPlansBuddyRouteImport } from './routes/_shell.plans.buddy'
import { Route as ShellPlansNowyRouteImport } from './routes/_shell.plans.nowy'
import { Route as ShellRaportyIndexRouteImport } from './routes/_shell.raporty.index'
import { Route as ShellRaportyTemplateIdRouteImport } from './routes/_shell.raporty.$templateId'
import { Route as ShellRaportyKatalogRouteImport } from './routes/_shell.raporty.katalog'
import { Route as ShellRaportyNowaRouteImport } from './routes/_shell.raporty.nowa'
import { Route as ShellZadaniaIndexRouteImport } from './routes/_shell.zadania.index'
import { Route as ShellZadaniaRodzajeRouteImport } from './routes/_shell.zadania.rodzaje'
import { Route as ShellKlienciZgloszeniaIndexRouteImport } from './routes/_shell.klienci.zgloszenia.index'
import { Route as ShellKlienciZgloszeniaLeadIdRouteImport } from './routes/_shell.klienci.zgloszenia.$leadId'
import { Route as ShellKlienciClientIdPlanAssignmentIdRouteImport } from './routes/_shell.klienci.$clientId_.plan.$assignmentId'

const ShellRoute = ShellRouteImport.update({
  id: '/_shell',
  getParentRoute: () => rootRouteImport,
} as any)
const CompleteProfileRoute = CompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => rootRouteImport,
} as any)
const PowitanieRoute = PowitanieRouteImport.update({
  id: '/powitanie',
  path: '/powitanie',
  getParentRoute: () => rootRouteImport,
} as any)
const RefusedRoute = RefusedRouteImport.update({
  id: '/refused',
  path: '/refused',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const ShellIndexRoute = ShellIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellBuddyRoute = ShellBuddyRouteImport.update({
  id: '/buddy',
  path: '/buddy',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCwiczeniaRoute = ShellCwiczeniaRouteImport.update({
  id: '/cwiczenia',
  path: '/cwiczenia',
  getParentRoute: () => ShellRoute,
} as any)
const ShellCzatRoute = ShellCzatRouteImport.update({
  id: '/czat',
  path: '/czat',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKontoRoute = ShellKontoRouteImport.update({
  id: '/konto',
  path: '/konto',
  getParentRoute: () => ShellRoute,
} as any)
const ShellNagraniaRoute = ShellNagraniaRouteImport.update({
  id: '/nagrania',
  path: '/nagrania',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPulpitRoute = ShellPulpitRouteImport.update({
  id: '/pulpit',
  path: '/pulpit',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRezerwacjeRoute = ShellRezerwacjeRouteImport.update({
  id: '/rezerwacje',
  path: '/rezerwacje',
  getParentRoute: () => ShellRoute,
} as any)
const ShellStronaRoute = ShellStronaRouteImport.update({
  id: '/strona',
  path: '/strona',
  getParentRoute: () => ShellRoute,
} as any)
const ShellWideoRoute = ShellWideoRouteImport.update({
  id: '/wideo',
  path: '/wideo',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlienciIndexRoute = ShellKlienciIndexRouteImport.update({
  id: '/klienci/',
  path: '/klienci/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlienciClientIdRoute = ShellKlienciClientIdRouteImport.update({
  id: '/klienci/$clientId',
  path: '/klienci/$clientId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlienciArchiwumRoute = ShellKlienciArchiwumRouteImport.update({
  id: '/klienci/archiwum',
  path: '/klienci/archiwum',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlienciFormularzRoute = ShellKlienciFormularzRouteImport.update({
  id: '/klienci/formularz',
  path: '/klienci/formularz',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKontoGoogleRoute = ShellKontoGoogleRouteImport.update({
  id: '/konto_/google',
  path: '/konto/google',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlansIndexRoute = ShellPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlansPlanIdRoute = ShellPlansPlanIdRouteImport.update({
  id: '/plans/$planId',
  path: '/plans/$planId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlansBuddyRoute = ShellPlansBuddyRouteImport.update({
  id: '/plans/buddy',
  path: '/plans/buddy',
  getParentRoute: () => ShellRoute,
} as any)
const ShellPlansNowyRoute = ShellPlansNowyRouteImport.update({
  id: '/plans/nowy',
  path: '/plans/nowy',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRaportyIndexRoute = ShellRaportyIndexRouteImport.update({
  id: '/raporty/',
  path: '/raporty/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRaportyTemplateIdRoute = ShellRaportyTemplateIdRouteImport.update({
  id: '/raporty/$templateId',
  path: '/raporty/$templateId',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRaportyKatalogRoute = ShellRaportyKatalogRouteImport.update({
  id: '/raporty/katalog',
  path: '/raporty/katalog',
  getParentRoute: () => ShellRoute,
} as any)
const ShellRaportyNowaRoute = ShellRaportyNowaRouteImport.update({
  id: '/raporty/nowa',
  path: '/raporty/nowa',
  getParentRoute: () => ShellRoute,
} as any)
const ShellZadaniaIndexRoute = ShellZadaniaIndexRouteImport.update({
  id: '/zadania/',
  path: '/zadania/',
  getParentRoute: () => ShellRoute,
} as any)
const ShellZadaniaRodzajeRoute = ShellZadaniaRodzajeRouteImport.update({
  id: '/zadania/rodzaje',
  path: '/zadania/rodzaje',
  getParentRoute: () => ShellRoute,
} as any)
const ShellKlienciZgloszeniaIndexRoute =
  ShellKlienciZgloszeniaIndexRouteImport.update({
    id: '/klienci/zgloszenia/',
    path: '/klienci/zgloszenia/',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellKlienciZgloszeniaLeadIdRoute =
  ShellKlienciZgloszeniaLeadIdRouteImport.update({
    id: '/klienci/zgloszenia/$leadId',
    path: '/klienci/zgloszenia/$leadId',
    getParentRoute: () => ShellRoute,
  } as any)
const ShellKlienciClientIdPlanAssignmentIdRoute =
  ShellKlienciClientIdPlanAssignmentIdRouteImport.update({
    id: '/klienci/$clientId_/plan/$assignmentId',
    path: '/klienci/$clientId/plan/$assignmentId',
    getParentRoute: () => ShellRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof ShellIndexRoute
  '/complete-profile': typeof CompleteProfileRoute
  '/powitanie': typeof PowitanieRoute
  '/refused': typeof RefusedRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/buddy': typeof ShellBuddyRoute
  '/cwiczenia': typeof ShellCwiczeniaRoute
  '/czat': typeof ShellCzatRoute
  '/konto': typeof ShellKontoRoute
  '/nagrania': typeof ShellNagraniaRoute
  '/pulpit': typeof ShellPulpitRoute
  '/rezerwacje': typeof ShellRezerwacjeRoute
  '/strona': typeof ShellStronaRoute
  '/wideo': typeof ShellWideoRoute
  '/klienci/$clientId': typeof ShellKlienciClientIdRoute
  '/klienci/archiwum': typeof ShellKlienciArchiwumRoute
  '/klienci/formularz': typeof ShellKlienciFormularzRoute
  '/konto/google': typeof ShellKontoGoogleRoute
  '/plans/$planId': typeof ShellPlansPlanIdRoute
  '/plans/buddy': typeof ShellPlansBuddyRoute
  '/plans/nowy': typeof ShellPlansNowyRoute
  '/raporty/$templateId': typeof ShellRaportyTemplateIdRoute
  '/raporty/katalog': typeof ShellRaportyKatalogRoute
  '/raporty/nowa': typeof ShellRaportyNowaRoute
  '/zadania/rodzaje': typeof ShellZadaniaRodzajeRoute
  '/klienci/': typeof ShellKlienciIndexRoute
  '/plans/': typeof ShellPlansIndexRoute
  '/raporty/': typeof ShellRaportyIndexRoute
  '/zadania/': typeof ShellZadaniaIndexRoute
  '/klienci/zgloszenia/$leadId': typeof ShellKlienciZgloszeniaLeadIdRoute
  '/klienci/zgloszenia/': typeof ShellKlienciZgloszeniaIndexRoute
  '/klienci/$clientId/plan/$assignmentId': typeof ShellKlienciClientIdPlanAssignmentIdRoute
}
export interface FileRoutesByTo {
  '/complete-profile': typeof CompleteProfileRoute
  '/powitanie': typeof PowitanieRoute
  '/refused': typeof RefusedRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/buddy': typeof ShellBuddyRoute
  '/cwiczenia': typeof ShellCwiczeniaRoute
  '/czat': typeof ShellCzatRoute
  '/konto': typeof ShellKontoRoute
  '/nagrania': typeof ShellNagraniaRoute
  '/pulpit': typeof ShellPulpitRoute
  '/rezerwacje': typeof ShellRezerwacjeRoute
  '/strona': typeof ShellStronaRoute
  '/wideo': typeof ShellWideoRoute
  '/': typeof ShellIndexRoute
  '/klienci/$clientId': typeof ShellKlienciClientIdRoute
  '/klienci/archiwum': typeof ShellKlienciArchiwumRoute
  '/klienci/formularz': typeof ShellKlienciFormularzRoute
  '/konto/google': typeof ShellKontoGoogleRoute
  '/plans/$planId': typeof ShellPlansPlanIdRoute
  '/plans/buddy': typeof ShellPlansBuddyRoute
  '/plans/nowy': typeof ShellPlansNowyRoute
  '/raporty/$templateId': typeof ShellRaportyTemplateIdRoute
  '/raporty/katalog': typeof ShellRaportyKatalogRoute
  '/raporty/nowa': typeof ShellRaportyNowaRoute
  '/zadania/rodzaje': typeof ShellZadaniaRodzajeRoute
  '/klienci': typeof ShellKlienciIndexRoute
  '/plans': typeof ShellPlansIndexRoute
  '/raporty': typeof ShellRaportyIndexRoute
  '/zadania': typeof ShellZadaniaIndexRoute
  '/klienci/zgloszenia/$leadId': typeof ShellKlienciZgloszeniaLeadIdRoute
  '/klienci/zgloszenia': typeof ShellKlienciZgloszeniaIndexRoute
  '/klienci/$clientId/plan/$assignmentId': typeof ShellKlienciClientIdPlanAssignmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_shell': typeof ShellRouteWithChildren
  '/complete-profile': typeof CompleteProfileRoute
  '/powitanie': typeof PowitanieRoute
  '/refused': typeof RefusedRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_shell/buddy': typeof ShellBuddyRoute
  '/_shell/cwiczenia': typeof ShellCwiczeniaRoute
  '/_shell/czat': typeof ShellCzatRoute
  '/_shell/konto': typeof ShellKontoRoute
  '/_shell/nagrania': typeof ShellNagraniaRoute
  '/_shell/pulpit': typeof ShellPulpitRoute
  '/_shell/rezerwacje': typeof ShellRezerwacjeRoute
  '/_shell/strona': typeof ShellStronaRoute
  '/_shell/wideo': typeof ShellWideoRoute
  '/_shell/': typeof ShellIndexRoute
  '/_shell/klienci/$clientId': typeof ShellKlienciClientIdRoute
  '/_shell/klienci/archiwum': typeof ShellKlienciArchiwumRoute
  '/_shell/klienci/formularz': typeof ShellKlienciFormularzRoute
  '/_shell/konto_/google': typeof ShellKontoGoogleRoute
  '/_shell/plans/$planId': typeof ShellPlansPlanIdRoute
  '/_shell/plans/buddy': typeof ShellPlansBuddyRoute
  '/_shell/plans/nowy': typeof ShellPlansNowyRoute
  '/_shell/raporty/$templateId': typeof ShellRaportyTemplateIdRoute
  '/_shell/raporty/katalog': typeof ShellRaportyKatalogRoute
  '/_shell/raporty/nowa': typeof ShellRaportyNowaRoute
  '/_shell/zadania/rodzaje': typeof ShellZadaniaRodzajeRoute
  '/_shell/klienci/': typeof ShellKlienciIndexRoute
  '/_shell/plans/': typeof ShellPlansIndexRoute
  '/_shell/raporty/': typeof ShellRaportyIndexRoute
  '/_shell/zadania/': typeof ShellZadaniaIndexRoute
  '/_shell/klienci/zgloszenia/$leadId': typeof ShellKlienciZgloszeniaLeadIdRoute
  '/_shell/klienci/zgloszenia/': typeof ShellKlienciZgloszeniaIndexRoute
  '/_shell/klienci/$clientId_/plan/$assignmentId': typeof ShellKlienciClientIdPlanAssignmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/complete-profile'
    | '/powitanie'
    | '/refused'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/buddy'
    | '/cwiczenia'
    | '/czat'
    | '/konto'
    | '/nagrania'
    | '/pulpit'
    | '/rezerwacje'
    | '/strona'
    | '/wideo'
    | '/klienci/$clientId'
    | '/klienci/archiwum'
    | '/klienci/formularz'
    | '/konto/google'
    | '/plans/$planId'
    | '/plans/buddy'
    | '/plans/nowy'
    | '/raporty/$templateId'
    | '/raporty/katalog'
    | '/raporty/nowa'
    | '/zadania/rodzaje'
    | '/klienci/'
    | '/plans/'
    | '/raporty/'
    | '/zadania/'
    | '/klienci/zgloszenia/$leadId'
    | '/klienci/zgloszenia/'
    | '/klienci/$clientId/plan/$assignmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/complete-profile'
    | '/powitanie'
    | '/refused'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/buddy'
    | '/cwiczenia'
    | '/czat'
    | '/konto'
    | '/nagrania'
    | '/pulpit'
    | '/rezerwacje'
    | '/strona'
    | '/wideo'
    | '/'
    | '/klienci/$clientId'
    | '/klienci/archiwum'
    | '/klienci/formularz'
    | '/konto/google'
    | '/plans/$planId'
    | '/plans/buddy'
    | '/plans/nowy'
    | '/raporty/$templateId'
    | '/raporty/katalog'
    | '/raporty/nowa'
    | '/zadania/rodzaje'
    | '/klienci'
    | '/plans'
    | '/raporty'
    | '/zadania'
    | '/klienci/zgloszenia/$leadId'
    | '/klienci/zgloszenia'
    | '/klienci/$clientId/plan/$assignmentId'
  id:
    | '__root__'
    | '/_shell'
    | '/complete-profile'
    | '/powitanie'
    | '/refused'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/_shell/buddy'
    | '/_shell/cwiczenia'
    | '/_shell/czat'
    | '/_shell/konto'
    | '/_shell/nagrania'
    | '/_shell/pulpit'
    | '/_shell/rezerwacje'
    | '/_shell/strona'
    | '/_shell/wideo'
    | '/_shell/'
    | '/_shell/klienci/$clientId'
    | '/_shell/klienci/archiwum'
    | '/_shell/klienci/formularz'
    | '/_shell/konto_/google'
    | '/_shell/plans/$planId'
    | '/_shell/plans/buddy'
    | '/_shell/plans/nowy'
    | '/_shell/raporty/$templateId'
    | '/_shell/raporty/katalog'
    | '/_shell/raporty/nowa'
    | '/_shell/zadania/rodzaje'
    | '/_shell/klienci/'
    | '/_shell/plans/'
    | '/_shell/raporty/'
    | '/_shell/zadania/'
    | '/_shell/klienci/zgloszenia/$leadId'
    | '/_shell/klienci/zgloszenia/'
    | '/_shell/klienci/$clientId_/plan/$assignmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  ShellRoute: typeof ShellRouteWithChildren
  CompleteProfileRoute: typeof CompleteProfileRoute
  PowitanieRoute: typeof PowitanieRoute
  RefusedRoute: typeof RefusedRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_shell': {
      id: '/_shell'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/complete-profile': {
      id: '/complete-profile'
      path: '/complete-profile'
      fullPath: '/complete-profile'
      preLoaderRoute: typeof CompleteProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/powitanie': {
      id: '/powitanie'
      path: '/powitanie'
      fullPath: '/powitanie'
      preLoaderRoute: typeof PowitanieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refused': {
      id: '/refused'
      path: '/refused'
      fullPath: '/refused'
      preLoaderRoute: typeof RefusedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_shell/': {
      id: '/_shell/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof ShellIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/buddy': {
      id: '/_shell/buddy'
      path: '/buddy'
      fullPath: '/buddy'
      preLoaderRoute: typeof ShellBuddyRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/cwiczenia': {
      id: '/_shell/cwiczenia'
      path: '/cwiczenia'
      fullPath: '/cwiczenia'
      preLoaderRoute: typeof ShellCwiczeniaRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/czat': {
      id: '/_shell/czat'
      path: '/czat'
      fullPath: '/czat'
      preLoaderRoute: typeof ShellCzatRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/konto': {
      id: '/_shell/konto'
      path: '/konto'
      fullPath: '/konto'
      preLoaderRoute: typeof ShellKontoRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/nagrania': {
      id: '/_shell/nagrania'
      path: '/nagrania'
      fullPath: '/nagrania'
      preLoaderRoute: typeof ShellNagraniaRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/pulpit': {
      id: '/_shell/pulpit'
      path: '/pulpit'
      fullPath: '/pulpit'
      preLoaderRoute: typeof ShellPulpitRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/rezerwacje': {
      id: '/_shell/rezerwacje'
      path: '/rezerwacje'
      fullPath: '/rezerwacje'
      preLoaderRoute: typeof ShellRezerwacjeRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/strona': {
      id: '/_shell/strona'
      path: '/strona'
      fullPath: '/strona'
      preLoaderRoute: typeof ShellStronaRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/wideo': {
      id: '/_shell/wideo'
      path: '/wideo'
      fullPath: '/wideo'
      preLoaderRoute: typeof ShellWideoRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/': {
      id: '/_shell/klienci/'
      path: '/klienci'
      fullPath: '/klienci/'
      preLoaderRoute: typeof ShellKlienciIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/$clientId': {
      id: '/_shell/klienci/$clientId'
      path: '/klienci/$clientId'
      fullPath: '/klienci/$clientId'
      preLoaderRoute: typeof ShellKlienciClientIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/archiwum': {
      id: '/_shell/klienci/archiwum'
      path: '/klienci/archiwum'
      fullPath: '/klienci/archiwum'
      preLoaderRoute: typeof ShellKlienciArchiwumRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/formularz': {
      id: '/_shell/klienci/formularz'
      path: '/klienci/formularz'
      fullPath: '/klienci/formularz'
      preLoaderRoute: typeof ShellKlienciFormularzRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/konto_/google': {
      id: '/_shell/konto_/google'
      path: '/konto/google'
      fullPath: '/konto/google'
      preLoaderRoute: typeof ShellKontoGoogleRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plans/': {
      id: '/_shell/plans/'
      path: '/plans'
      fullPath: '/plans/'
      preLoaderRoute: typeof ShellPlansIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plans/$planId': {
      id: '/_shell/plans/$planId'
      path: '/plans/$planId'
      fullPath: '/plans/$planId'
      preLoaderRoute: typeof ShellPlansPlanIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plans/buddy': {
      id: '/_shell/plans/buddy'
      path: '/plans/buddy'
      fullPath: '/plans/buddy'
      preLoaderRoute: typeof ShellPlansBuddyRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/plans/nowy': {
      id: '/_shell/plans/nowy'
      path: '/plans/nowy'
      fullPath: '/plans/nowy'
      preLoaderRoute: typeof ShellPlansNowyRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/raporty/': {
      id: '/_shell/raporty/'
      path: '/raporty'
      fullPath: '/raporty/'
      preLoaderRoute: typeof ShellRaportyIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/raporty/$templateId': {
      id: '/_shell/raporty/$templateId'
      path: '/raporty/$templateId'
      fullPath: '/raporty/$templateId'
      preLoaderRoute: typeof ShellRaportyTemplateIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/raporty/katalog': {
      id: '/_shell/raporty/katalog'
      path: '/raporty/katalog'
      fullPath: '/raporty/katalog'
      preLoaderRoute: typeof ShellRaportyKatalogRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/raporty/nowa': {
      id: '/_shell/raporty/nowa'
      path: '/raporty/nowa'
      fullPath: '/raporty/nowa'
      preLoaderRoute: typeof ShellRaportyNowaRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/zadania/': {
      id: '/_shell/zadania/'
      path: '/zadania'
      fullPath: '/zadania/'
      preLoaderRoute: typeof ShellZadaniaIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/zadania/rodzaje': {
      id: '/_shell/zadania/rodzaje'
      path: '/zadania/rodzaje'
      fullPath: '/zadania/rodzaje'
      preLoaderRoute: typeof ShellZadaniaRodzajeRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/zgloszenia/': {
      id: '/_shell/klienci/zgloszenia/'
      path: '/klienci/zgloszenia'
      fullPath: '/klienci/zgloszenia/'
      preLoaderRoute: typeof ShellKlienciZgloszeniaIndexRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/zgloszenia/$leadId': {
      id: '/_shell/klienci/zgloszenia/$leadId'
      path: '/klienci/zgloszenia/$leadId'
      fullPath: '/klienci/zgloszenia/$leadId'
      preLoaderRoute: typeof ShellKlienciZgloszeniaLeadIdRouteImport
      parentRoute: typeof ShellRoute
    }
    '/_shell/klienci/$clientId_/plan/$assignmentId': {
      id: '/_shell/klienci/$clientId_/plan/$assignmentId'
      path: '/klienci/$clientId/plan/$assignmentId'
      fullPath: '/klienci/$clientId/plan/$assignmentId'
      preLoaderRoute: typeof ShellKlienciClientIdPlanAssignmentIdRouteImport
      parentRoute: typeof ShellRoute
    }
  }
}

interface ShellRouteChildren {
  ShellBuddyRoute: typeof ShellBuddyRoute
  ShellCwiczeniaRoute: typeof ShellCwiczeniaRoute
  ShellCzatRoute: typeof ShellCzatRoute
  ShellKontoRoute: typeof ShellKontoRoute
  ShellNagraniaRoute: typeof ShellNagraniaRoute
  ShellPulpitRoute: typeof ShellPulpitRoute
  ShellRezerwacjeRoute: typeof ShellRezerwacjeRoute
  ShellStronaRoute: typeof ShellStronaRoute
  ShellWideoRoute: typeof ShellWideoRoute
  ShellIndexRoute: typeof ShellIndexRoute
  ShellKlienciClientIdRoute: typeof ShellKlienciClientIdRoute
  ShellKlienciArchiwumRoute: typeof ShellKlienciArchiwumRoute
  ShellKlienciFormularzRoute: typeof ShellKlienciFormularzRoute
  ShellKontoGoogleRoute: typeof ShellKontoGoogleRoute
  ShellPlansPlanIdRoute: typeof ShellPlansPlanIdRoute
  ShellPlansBuddyRoute: typeof ShellPlansBuddyRoute
  ShellPlansNowyRoute: typeof ShellPlansNowyRoute
  ShellRaportyTemplateIdRoute: typeof ShellRaportyTemplateIdRoute
  ShellRaportyKatalogRoute: typeof ShellRaportyKatalogRoute
  ShellRaportyNowaRoute: typeof ShellRaportyNowaRoute
  ShellZadaniaRodzajeRoute: typeof ShellZadaniaRodzajeRoute
  ShellKlienciIndexRoute: typeof ShellKlienciIndexRoute
  ShellPlansIndexRoute: typeof ShellPlansIndexRoute
  ShellRaportyIndexRoute: typeof ShellRaportyIndexRoute
  ShellZadaniaIndexRoute: typeof ShellZadaniaIndexRoute
  ShellKlienciZgloszeniaLeadIdRoute: typeof ShellKlienciZgloszeniaLeadIdRoute
  ShellKlienciZgloszeniaIndexRoute: typeof ShellKlienciZgloszeniaIndexRoute
  ShellKlienciClientIdPlanAssignmentIdRoute: typeof ShellKlienciClientIdPlanAssignmentIdRoute
}

const ShellRouteChildren: ShellRouteChildren = {
  ShellBuddyRoute: ShellBuddyRoute,
  ShellCwiczeniaRoute: ShellCwiczeniaRoute,
  ShellCzatRoute: ShellCzatRoute,
  ShellKontoRoute: ShellKontoRoute,
  ShellNagraniaRoute: ShellNagraniaRoute,
  ShellPulpitRoute: ShellPulpitRoute,
  ShellRezerwacjeRoute: ShellRezerwacjeRoute,
  ShellStronaRoute: ShellStronaRoute,
  ShellWideoRoute: ShellWideoRoute,
  ShellIndexRoute: ShellIndexRoute,
  ShellKlienciClientIdRoute: ShellKlienciClientIdRoute,
  ShellKlienciArchiwumRoute: ShellKlienciArchiwumRoute,
  ShellKlienciFormularzRoute: ShellKlienciFormularzRoute,
  ShellKontoGoogleRoute: ShellKontoGoogleRoute,
  ShellPlansPlanIdRoute: ShellPlansPlanIdRoute,
  ShellPlansBuddyRoute: ShellPlansBuddyRoute,
  ShellPlansNowyRoute: ShellPlansNowyRoute,
  ShellRaportyTemplateIdRoute: ShellRaportyTemplateIdRoute,
  ShellRaportyKatalogRoute: ShellRaportyKatalogRoute,
  ShellRaportyNowaRoute: ShellRaportyNowaRoute,
  ShellZadaniaRodzajeRoute: ShellZadaniaRodzajeRoute,
  ShellKlienciIndexRoute: ShellKlienciIndexRoute,
  ShellPlansIndexRoute: ShellPlansIndexRoute,
  ShellRaportyIndexRoute: ShellRaportyIndexRoute,
  ShellZadaniaIndexRoute: ShellZadaniaIndexRoute,
  ShellKlienciZgloszeniaLeadIdRoute: ShellKlienciZgloszeniaLeadIdRoute,
  ShellKlienciZgloszeniaIndexRoute: ShellKlienciZgloszeniaIndexRoute,
  ShellKlienciClientIdPlanAssignmentIdRoute:
    ShellKlienciClientIdPlanAssignmentIdRoute,
}

const ShellRouteWithChildren = ShellRoute._addFileChildren(ShellRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  ShellRoute: ShellRouteWithChildren,
  CompleteProfileRoute: CompleteProfileRoute,
  PowitanieRoute: PowitanieRoute,
  RefusedRoute: RefusedRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
